__webpack_require__.p = "/assets/web_russia/";